import React from 'react';
import ChargingIcon from '../../assets/svg/bolt.svg';

const BatteryAndConnection = ({ unit }) => {
  return (
    <div className='statusAll'>
      <div className={unit.signalQuality} title={unit.modemname} />
      <div className='battery-status'>
        <span className='statuslabel'>
          {unit.showbattery ? (
            <div className={`progress ${unit.batterystatuscharging}`}>
              <div className='prog-wrap'>
                <div
                  className='progress-bar progress-bar-v'
                  role='progressbar'
                  // eslint-disable-next-line jsx-a11y/aria-proptypes
                  aria-valuenow="{{selectedunit.batterystatusvalue | ifEmpty:'N/A'}}"
                  aria-valuemin='0'
                  aria-valuemax='100'
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    alignItems: 'center',
                    width: unit.batterystatuswidth,
                    backgroundColor: unit.batterystatuscolor,
                    color: '#000',
                  }}
                />
                <div>
                  {!unit.battery.discharging && (
                    <img
                      src={ChargingIcon}
                      alt='Charging'
                      style={{
                        position: 'absolute',
                        right: '0px',
                        height: '8px',
                        width: '10px',
                        top: '2px',
                      }}
                    />
                  )}
                  <span
                    style={{
                      position: 'absolute',
                      right: !unit.battery.discharging ? '5px' : '0px',
                      margin: '0 auto',
                      textAlign: 'center',
                      left: '0',
                      fontSize: '10px',
                      fontWeight: 700,
                      top: '6px',
                      color: '#000',
                    }}
                  >
                    {unit.batterystatusvalue}
                  </span>
                </div>
              </div>
              <span className='sr-only'>{unit.batterystatus}</span>
            </div>
          ) : (
            <span className='natxt'></span>
          )}
        </span>
      </div>
    </div>
  );
};

export default BatteryAndConnection;
